import Button from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Container = styled.div<{
	scale: number;
	$backgroundImage: string;
}>`
	width: 31.9em;
	//height: 25.3em;
	padding: 1.2em;
	position: relative;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	gap: 1em;
	border-radius: 2.4em;
	font-size: 10px;
	transform: scale(${(props) => props.scale});
	box-shadow: 0 0.02em 0.06em 0 rgba(0, 0, 0, 0.45);
	background-image: url(${(props) => props.$backgroundImage});
	background-size: cover;
	background-repeat: no-repeat;
`;

export const Text = styled.div`
	font-family: "Baloo";
	-webkit-text-stroke-width: 0.15em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	color: #fff;
	//filter: drop-shadow(0.0108em 0.0308em 0 #000);
	filter: drop-shadow(0 0.049em 0 #000);
	font-style: normal;
	font-weight: 400;
`;

export const Title = styled(Text)`
	margin: 1em 0 0 0;
	font-size: 3.4em;
	line-height: 91.176%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 9em;
`;

export const SubTitle = styled.p`
	color: #333;
	font-family: "Inter";
	font-size: 1.6em;
	font-style: normal;
	font-weight: 700;
	line-height: 112.5%;
`;

export const OfferText = styled(Text)`
	width: 100%;
	font-size: 1.5em;
	line-height: 1.4em;
	display: flex;
	align-items: start;
	-webkit-text-stroke-width: 0.2em;
	margin-left: 0.5em;
`;

export const CustomButton = styled(Button)`
	width: 15.1904em;
	height: 2.7142em;
	font-size: 2.1em;
`;

export const OffersContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Offer = styled.div`
	position: relative;
	width: 100%;
`;

export const OfferItem = styled.div`
	position: relative;
	z-index: 1;
	grid-template-rows: auto;
	background-color: rgba(0, 0, 0, 0.25);
	backdrop-filter: blur(14px);
	border-radius: 12px;
	padding: 1em;
	gap: 0.5rem;
	box-sizing: border-box;
	height: 10em;
	align-content: stretch;
	width: 100%;
`;

export const Items = styled.div`
	justify-content: center;
	align-items: center;
	display: flex;
	flex-wrap: nowrap;
	height: 100%;
`;

export const RewardItem = styled.div<{ width: string }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${(props) => props.width};
	box-sizing: border-box;
	gap: 0.2em;
`;

export const ItemImage = styled.img`
	object-fit: contain;
	justify-self: center;
	align-self: center;

	width: 100%;
	height: 5em;
`;

export const RewardAmount = styled(Text)`
	font-size: 2.1em;
	line-height: 1em;
`;
